import React from 'react';
import { Link } from 'react-router-dom';

function Privacidade() {
  return (
    <>
      <div className="header">
        <Link to="/cadastro" className="header-logo">
          <img src={require('../logo.png')} alt="PokerMind Brasil" style={{ height: '46px', objectFit: 'contain' }} />
        </Link>
        <Link to="/cadastro" className="header-back">← Voltar ao cadastro</Link>
      </div>

      <div className="content content-blue">
        <div className="doc-tag doc-tag-blue">Documento Legal</div>
        <h1 className="doc-title">Política de Privacidade</h1>
        <div className="doc-date">Última atualização: março de 2026 · PokerMind Brasil</div>

        <div className="highlight-box" style={{background: 'rgba(56,189,248,.05)', border: '1px solid rgba(56,189,248,.15)'}}>
          <p>Sua privacidade é importante para nós. Esta política explica quais dados coletamos, como usamos e como você pode controlar suas informações.</p>
        </div>

        <h2 style={{color: 'var(--blue)'}}>1. Quem Somos</h2>
        <p>O PokerMind Brasil é uma plataforma de educação em poker operada no Brasil. Para dúvidas sobre privacidade, entre em contato pelo e-mail <a href="mailto:contato@pokermindbrasil.com" style={{color: 'var(--blue)'}}>contato@pokermindbrasil.com</a>.</p>

        <h2 style={{color: 'var(--blue)'}}>2. Dados que Coletamos</h2>
        <table className="data-table">
          <thead>
            <tr>
              <th>Dado</th>
              <th>Finalidade</th>
              <th>Base legal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Nome e e-mail</strong></td>
              <td>Criação e gerenciamento da conta</td>
              <td>Execução de contrato</td>
            </tr>
            <tr>
              <td><strong>Histórico de mãos (.txt)</strong></td>
              <td>Análise de desempenho e geração de insights</td>
              <td>Execução de contrato</td>
            </tr>
            <tr>
              <td><strong>Conversas com o Coach IA</strong></td>
              <td>Personalização e memória entre sessões</td>
              <td>Execução de contrato</td>
            </tr>
            <tr>
              <td><strong>Dados de uso da plataforma</strong></td>
              <td>Melhoria do produto e análise de comportamento</td>
              <td>Interesse legítimo</td>
            </tr>
            <tr>
              <td><strong>Dados de pagamento</strong></td>
              <td>Processamento de assinaturas (via Kiwify)</td>
              <td>Execução de contrato</td>
            </tr>
            <tr>
              <td><strong>Respostas do onboarding</strong></td>
              <td>Personalização do plano de estudo</td>
              <td>Consentimento</td>
            </tr>
          </tbody>
        </table>

        <h2 style={{color: 'var(--blue)'}}>3. Como Usamos seus Dados</h2>
        <p>Utilizamos seus dados para:</p>
        <ul>
          <li>Criar e manter sua conta na plataforma;</li>
          <li>Personalizar o Coach IA com base no seu histórico de jogo;</li>
          <li>Gerar análises, relatórios e planos de estudo;</li>
          <li>Processar pagamentos e gerenciar assinaturas;</li>
          <li>Enviar comunicações sobre a plataforma (e-mails transacionais e de produto);</li>
          <li>Melhorar continuamente os nossos serviços.</li>
        </ul>

        <h2 style={{color: 'var(--blue)'}}>4. Compartilhamento de Dados</h2>
        <p>Não vendemos seus dados pessoais. Compartilhamos informações apenas com:</p>
        <ul>
          <li><strong>Kiwify:</strong> processamento de pagamentos e gestão de assinaturas;</li>
          <li><strong>Provedores de IA:</strong> para processamento das análises do Coach IA (dados anonimizados quando possível);</li>
          <li><strong>Infraestrutura de nuvem:</strong> armazenamento seguro dos dados da plataforma;</li>
          <li><strong>Autoridades legais:</strong> quando exigido por lei ou ordem judicial.</li>
        </ul>

        <h2 style={{color: 'var(--blue)'}}>5. Retenção de Dados</h2>
        <p>Mantemos seus dados enquanto sua conta estiver ativa. Após o encerramento da conta:</p>
        <ul>
          <li>Dados de conta são excluídos em até 30 dias;</li>
          <li>Histórico de mãos e conversas com o Coach IA são excluídos em até 60 dias;</li>
          <li>Dados de pagamento são mantidos pelo prazo legal exigido (5 anos).</li>
        </ul>

        <h2 style={{color: 'var(--blue)'}}>6. Seus Direitos (LGPD)</h2>
        <p>Conforme a Lei Geral de Proteção de Dados (Lei 13.709/2018), você tem direito a:</p>
        <ul>
          <li><strong>Acesso:</strong> saber quais dados temos sobre você;</li>
          <li><strong>Correção:</strong> corrigir dados incorretos ou desatualizados;</li>
          <li><strong>Exclusão:</strong> solicitar a exclusão dos seus dados;</li>
          <li><strong>Portabilidade:</strong> receber seus dados em formato estruturado;</li>
          <li><strong>Oposição:</strong> opor-se ao tratamento em determinadas situações;</li>
          <li><strong>Revogação:</strong> revogar consentimentos dados anteriormente.</li>
        </ul>
        <p>Para exercer esses direitos, entre em contato pelo e-mail <a href="mailto:contato@pokermindbrasil.com" style={{color: 'var(--blue)'}}>contato@pokermindbrasil.com</a>. Responderemos em até 15 dias úteis.</p>

        <h2 style={{color: 'var(--blue)'}}>7. Segurança</h2>
        <p>Adotamos medidas técnicas e organizacionais para proteger seus dados, incluindo criptografia em trânsito (HTTPS), controle de acesso restrito e monitoramento de segurança. Em caso de incidente que possa afetar seus dados, notificaremos no prazo legal.</p>

        <h2 style={{color: 'var(--blue)'}}>8. Cookies e Rastreamento</h2>
        <p>Utilizamos cookies essenciais para o funcionamento da plataforma (sessão, autenticação) e cookies analíticos para entender como a plataforma é utilizada. Você pode desabilitar cookies analíticos nas configurações do seu navegador sem impacto no funcionamento básico.</p>

        <h2 style={{color: 'var(--blue)'}}>9. Menores de Idade</h2>
        <p>O PokerMind Brasil não é destinado a menores de 18 anos. Não coletamos intencionalmente dados de menores. Se identificarmos uma conta de menor de idade, ela será encerrada.</p>

        <h2 style={{color: 'var(--blue)'}}>10. Alterações nesta Política</h2>
        <p>Podemos atualizar esta Política periodicamente. Alterações relevantes serão comunicadas por e-mail. A data da última atualização sempre estará indicada no topo deste documento.</p>

        <h2 style={{color: 'var(--blue)'}}>11. Contato</h2>
        <p>Para questões de privacidade: <a href="mailto:contato@pokermindbrasil.com" style={{color: 'var(--blue)'}}>contato@pokermindbrasil.com</a></p>
      </div>

      <div className="footer" style={{borderTop: '1px solid var(--border)'}}>
        © 2026 PokerMind Brasil · <Link to="/termos" style={{color: 'var(--blue)'}}>Termos de Uso</Link> · <Link to="/privacidade" style={{color: 'var(--blue)'}}>Política de Privacidade</Link>
      </div>
    </>
  );
}

export default Privacidade;
